// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@400;500);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oqfKnJUOOCEc7VqWYoKw {
  position: fixed;
  bottom: 16px;
  right: 16px;
  z-index: 1;
  pointer-events: all;
}
.oqfKnJUOOCEc7VqWYoKw .S_CQlESisZsC47QV2FzW {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.oqfKnJUOOCEc7VqWYoKw .S_CQlESisZsC47QV2FzW .Th5tKvxu5f5MK2okdCkI {
  width: 16px;
  height: 16px;
  opacity: 0;
  margin-left: -22px;
  transition: all 0.2s ease;
}
.oqfKnJUOOCEc7VqWYoKw .S_CQlESisZsC47QV2FzW .Th5tKvxu5f5MK2okdCkI path {
  fill: white;
}
.oqfKnJUOOCEc7VqWYoKw .S_CQlESisZsC47QV2FzW .sifGyII2Wf10CAM6HTQU {
  font-size: 11px;
  font-weight: 500;
  color: white;
  white-space: nowrap;
  text-align: right;
}
.oqfKnJUOOCEc7VqWYoKw .S_CQlESisZsC47QV2FzW.i_1re1U1ZXw792X3Cp1L {
  background-color: rgba(50, 50, 50, 0.8);
}
.oqfKnJUOOCEc7VqWYoKw .S_CQlESisZsC47QV2FzW.i_1re1U1ZXw792X3Cp1L .Th5tKvxu5f5MK2okdCkI {
  opacity: 1;
  margin-left: 0;
}`, "",{"version":3,"sources":["webpack://./src/editor/components/elements/GeoLocationDisplay/GeoLocationDisplay.module.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,mBAAA;AAAF;AAEE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;AAAJ;AAEI;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,yBAAA;AAAN;AAEM;EACE,WAAA;AAAR;AAII;EACE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;AAFN;AAKI;EACE,uCAAA;AAHN;AAKM;EACE,UAAA;EACA,cAAA;AAHR","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"geoLocationDisplay": `oqfKnJUOOCEc7VqWYoKw`,
	"content": `S_CQlESisZsC47QV2FzW`,
	"searchIcon": `Th5tKvxu5f5MK2okdCkI`,
	"locationText": `sifGyII2Wf10CAM6HTQU`,
	"hovered": `i_1re1U1ZXw792X3Cp1L`
};
export default ___CSS_LOADER_EXPORT___;
